module.exports = __webpack_public_path__ + "img/rfid抗金属.dca0ad28.jpg";